import { api } from './api'
import type { DataCategory, ApiResponse, PaginatedResponse } from '../types'

export interface DataCategoriesQuery {
  page?: number
  limit?: number
  search?: string
  type?: string
}

export class DataCategoriesService {
  /**
   * Get all data categories with optional filtering
   */
  static async getDataCategories(
    query: DataCategoriesQuery = {}
  ): Promise<PaginatedResponse<DataCategory>> {
    const params = new URLSearchParams()

    if (query.page) params.append('page', query.page.toString())
    if (query.limit) params.append('limit', query.limit.toString())
    if (query.search) params.append('search', query.search)
    if (query.type) params.append('type', query.type)

    const response = await api.get<PaginatedResponse<DataCategory>>(
      `/data-categories/?${params.toString()}`
    )

    return response.data
  }

  /**
   * Get a single data category by ID
   */
  static async getDataCategory(id: string): Promise<DataCategory> {
    const response = await api.get<ApiResponse<DataCategory>>(`/data-categories/${id}`)
    return response.data.data
  }

  /**
   * Create a new data category
   */
  static async createDataCategory(
    data: Omit<DataCategory, 'id' | 'createdAt' | 'updatedAt'>
  ): Promise<DataCategory> {
    const response = await api.post<ApiResponse<DataCategory>>('/data-categories/', data)
    return response.data.data
  }

  /**
   * Update an existing data category
   */
  static async updateDataCategory(
    id: string,
    data: Partial<Omit<DataCategory, 'id' | 'createdAt' | 'updatedAt'>>
  ): Promise<DataCategory> {
    const response = await api.put<ApiResponse<DataCategory>>(`/data-categories/${id}`, data)
    return response.data.data
  }

  /**
   * Delete a data category
   */
  static async deleteDataCategory(id: string): Promise<void> {
    await api.delete(`/data-categories/${id}`)
  }

  /**
   * Get data category types (for filtering)
   */
  static async getDataCategoryTypes(): Promise<string[]> {
    const response = await api.get<ApiResponse<string[]>>('/data-categories/types')
    return response.data.data
  }
}